// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messageButtonHeight[data-v-e76b8c96] button {\n  height: 34px;\n}\n.svgColor[data-v-e76b8c96] {\n  color: rgb(156, 163, 175);\n}\n.chipHeight[data-v-e76b8c96] {\n  height: 34px;\n}\n.filledHeart[data-v-e76b8c96] {\n  fill: #1A7BEE;\n  color: #1A7BEE;\n}\n.filledHeart[data-v-e76b8c96]:hover {\n  fill: #094c8b;\n  color: #094c8b;\n}\n.emailIcon[data-v-e76b8c96] {\n  fill: #1A7BEE;\n  color: white;\n}\n.emailIcon[data-v-e76b8c96]:hover {\n  fill: #094c8b;\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
